import styles from "./index.module.less";
import jiantou from "@/assets/lottie/jiantou.json";
import { Flex } from "antd";
import ChannelCard, { ChannelCardProps } from "./components/ChannelCard";
import AllianceList from "./components/AllianceList";
import { useEffect, useRef, useState } from "react";
import useHoverLottie from "@/hooks/useHoverLottie";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import JiantouIcon from "./imgs/jiantou.svg?react";
import SVGIcon from "@/components/SVGIcon";
import cooperationCasesData from "../cooperationCases/data";
import { partnerList } from "../home/components/PartnerList";
import { useStore } from "@/stores";
import P1Content from "@/components/P1Content";
import TitleWithBorder from "@/components/TitleWithBorder";
import { channelCardList, cooperationTexts } from "./data";
import data from "./data";
import { isMobile } from "@/utils";
import MobileCooperation from "./mobile";

const Cooperation = () => {
  const appStore = useStore("app");

  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.p1}>
        <P1Content title={data.p1.title} subtitle={data.p1.subtitle} showBtn={data.p1.showBtn} />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <TitleWithBorder text={data.p2.title} />
          <Flex className={styles.p2_content} wrap="wrap">
            {partnerList.flat().map((item, index) => (
              <div
                className={styles.p2_item}
                onClick={() => {
                  if (item.link) {
                    window.open(item.link, "_blank");
                  }
                }}
              >
                <div className={styles.p2_item_img}>
                  <img src={item.squareImg} alt="合作伙伴" />
                </div>
                <Flex vertical gap={".28rem"} className={styles.p2_item_content}>
                  <img style={{ width: ".4rem" }} src={item.icon} />
                  <div className={styles.p2_item_content_text}>
                    <div className={styles.subTitle}>{item.subTitle}</div>
                    <div className={styles.desc}>{item.desc}</div>
                  </div>
                </Flex>
                <img className={styles.titleImg} src={item.titleImg} />
              </div>
            ))}
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <TitleWithBorder text={data.p3.title} />
          <div className={styles.p3_list}>
            <Flex vertical gap={'.2rem'}>
              <Flex gap={'.2rem'} align="stretch">
                <ChannelCard {...channelCardList[0]} />
                <Flex gap={'.2rem'} vertical style={{ flex: 1 }}>
                  <ChannelCard {...channelCardList[1]} />
                  <ChannelCard {...channelCardList[2]} />
                </Flex>
                <Flex gap={'.2rem'} vertical style={{ flex: 1 }}>
                  <ChannelCard {...channelCardList[3]} />
                  {/* <ChannelCard {...channelCardList[4]} /> */}
                </Flex>
                <Flex gap={'.2rem'} vertical style={{ flex: 1 }}>
                  <ChannelCard {...channelCardList[4]} />
                  <ChannelCard {...channelCardList[5]} />
                </Flex>
              </Flex>
              <Flex gap={'.2rem'} align="stretch">
                <ChannelCard {...channelCardList[6]} />
                <ChannelCard {...channelCardList[7]} />
                <ChannelCard {...channelCardList[8]} />
                <ChannelCard
                  type="more"
                  onClick={() => {
                    navigate("/cooperation/cases");
                  }}
                />
              </Flex>
            </Flex>
          </div>
        </div>
      </div>
      {/* <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <div className={styles.p4_title}>AI数字服务商联盟</div>
          <div className={styles.p4_content}>
            <AllianceList />
          </div>
        </div>
      </div> */}
      <div className={styles.p5}>
        <div className={styles.p5_inner}>
          <div className={styles.p5_title}>
            <span>{data.p5.title[0]}</span>
            <br />
            {data.p5.title[1]}
          </div>
          <div className={styles.p5_content}>
            <div className={styles.p5_list}>
              {data.p5.steps.map((step, idx) => (
                <div className={styles.p5_list_item} key={idx}>
                  <div className={styles.p5_list_item_index}>{idx + 1}</div>
                  <div className={styles.p5_list_item_text}>{step}</div>
                </div>
              ))}
            </div>
            <div className={styles.p5_button}>
              {data.p5.buttonTexts.map((text, index) => (
                <Flex
                  align="center"
                  gap={4}
                  className={classNames(styles.fadingText, {
                    [styles.text_1]: index === 0,
                    [styles.text_2]: index === 1,
                    [styles.text_3]: index === 2,
                  })}
                  key={index}
                  onClick={() => {
                    appStore.openContactModal();
                  }}
                >
                  {text}
                  <SVGIcon icon={<JiantouIcon />} />
                </Flex>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default isMobile() ? MobileCooperation : Cooperation;
